export const CURRENCIES = [
  { code: "GBP", name: "Pound Sterling", country: "United Kingdom", locale: "en-GB" },
  { code: "USD", name: "US Dollar", country: "United States", locale: "en-US" },
  { code: "CAD", name: "Canadian Dollar", country: "Canada", locale: "en-GB" },
  { code: "JPY", name: "Japanese Yen", country: "Japan", locale: "ja-JP" },
  { code: "AUD", name: "Australian Dollar", country: "Australia", locale: "en-GB" },
  { code: "CNY", name: "Chinese Yuan", country: "China", locale: "en-GB" },
  { code: "EUR", name: "Euro", country: "Eurozone", locale: "en-IE" },
  { code: "CHF", name: "Swiss Franc", country: "Switzerland", locale: "de-CH" },
  { code: "INR", name: "Indian Rupee", country: "India", locale: "en-IN" },
  { code: "HKD", name: "Hong Kong Dollar", country: "Hong Kong", locale: "en-GB" },
];

let fx = { code: "GBP", rate: 1 };
export const setFx = (code, rate) => { fx = { code, rate: Number(rate) || 1 }; };
export const getFx = () => fx;

const meta = (code) => CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];
const decimals = (code) => (code === "JPY" ? 0 : 2);

export const formatIn = (v, code) =>
  new Intl.NumberFormat(meta(code).locale, { style: "currency", currency: code, maximumFractionDigits: decimals(code), minimumFractionDigits: decimals(code) }).format(v);

export const curSymbol = (code = fx.code) =>
  new Intl.NumberFormat(meta(code).locale, { style: "currency", currency: code }).formatToParts(0).find((p) => p.type === "currency")?.value || code;

// Values from the API are GBP; these show them in the user's chosen currency.
export const toDisplay = (n) => { const f = 10 ** decimals(fx.code); return Math.round(Number(n || 0) * fx.rate * f) / f; };
export const toGbp = (v) => Math.round((parseFloat(v || 0) / fx.rate) * 100) / 100;

export const gbp = (n) => formatIn(Number(n || 0) * fx.rate, fx.code);

export const gbpSigned = (n) => {
  const v = Number(n || 0);
  return (v >= 0 ? "+" : "-") + gbp(Math.abs(v));
};

export const compactMoney = (n) => {
  const v = Number(n || 0) * fx.rate;
  const s = curSymbol();
  return Math.abs(v) >= 1000 ? `${s}${(v / 1000).toFixed(v >= 10000 ? 0 : 1)}k` : `${s}${Math.round(v)}`;
};

// Real GBP amounts that must not be converted (e.g. Premium prices charged in pounds).
export const realGbp = (n) => formatIn(Number(n || 0), "GBP");

export const localizeText = (s) =>
  fx.code === "GBP" || !s ? s : String(s).replace(/£\s?(\d[\d,]*(?:\.\d+)?)/g, (m, num, at, str) =>
    (/FSCS[^.£]{0,30}$/.test(str.slice(Math.max(0, at - 45), at)) ? m : gbp(parseFloat(num.replace(/,/g, "")))));

export const shortDate = (ts) =>
  new Date(ts).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

export const fullDate = (ts) =>
  new Date(ts).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
